var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 7.99996C1.33337 5.4858 1.33337 4.22872 2.11442 3.44767C2.89547 2.66663 4.15255 2.66663 6.66671 2.66663H9.33337C11.8475 2.66663 13.1046 2.66663 13.8857 3.44767C14.6667 4.22872 14.6667 5.4858 14.6667 7.99996C14.6667 10.5141 14.6667 11.7712 13.8857 12.5522C13.1046 13.3333 11.8475 13.3333 9.33337 13.3333H6.66671C4.15255 13.3333 2.89547 13.3333 2.11442 12.5522C1.33337 11.7712 1.33337 10.5141 1.33337 7.99996Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33337L5.43926 6.53276C6.66369 7.55311 7.2759 8.06329 8 8.06329C8.7241 8.06329 9.33631 7.55311 10.5607 6.53276L12 5.33337",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email1.de8777cb9595ebc6c783d5e0e31630fc.svg";
export { ForwardRef as ReactComponent };